/**
 * @description 藏品标题信息
*/
import React from "react";
import './index.scss';

const CollectionTitle = (props) => {
  const { detailList, issuerInfo } = props;
  return (
        <div className="collection_title">
            <div className="title">{detailList?.collectionName}</div>
            <div className="message">
                <div className="company">发行方</div>
                <div className="quantity">
                    {detailList?.collectionType === 312 || detailList?.collectionType === 313? <img src={require("@/assets/img/lvdi2.jpeg")} alt="" /> : <img src={issuerInfo?.issuerLogo || require("@/assets/img/lvdi.png")} alt="" />}
                    {issuerInfo?.issuerName || detailList?.owner}
                </div>
            </div>
        </div>
    )
}

/**
 * @description 藏品编号
*/
const CollectionNo = (props)=> {
    const { detailList } = props;

    return (
        <div className={`collection_no`}>
            <div className="cell">
            <span className="collection-num">藏品编号</span>
            <span className="num">#{detailList?.nftNo}</span>
            </div>
            {!!detailList?.targetNftNo && !!detailList?.parent &&
            <div className="cell">
                <span className="collection-num">
                {detailList?.parent == 1 && '共创绑定'}
                {detailList?.parent == 2 && '关联藏品'}
                </span>
                <span className="num">#{detailList?.targetNftNo}</span>
            </div>
            }
        </div>
    )
}
/**
 * 藏品权益
 */
const CollectionBenefit = (props)=> {

  return (
    <div className={`collection_no`}>
      <div className="cell">
        <span className="collection-num">藏品权益</span>
        {props?.nftNo ? props?.seriesId ==='21'? <span className="num" style={{color: props?.isPick && props?.outPick ? '' : '#B89969'}}>{props?.isPick ? props?.outPick?'已领取':'部分领取' : props?.outPick?'部分领取':'未领取'}</span>
        : <span className="num" style={{color: props?.isPick ? '' : '#B89969'}}>{props?.isPick ? '已领取': '未领取'}</span> : ''}
      </div>
      {!props?.equityData && <div className="num">商城优惠券</div>}
      {!props?.equityData && <br/>}
      {!props?.equityData && <div className="num">绿地蓝町庄园Green606红酒</div>}
      {props?.equityData?.length > 0 && props?.equityData.map((item, index) => {
        return (
          <div>
            <div className="num">{item.goodsName}</div>
            <br/>
          </div>
        )
      })}
    </div>
  )
}

/**
 * 发行平台-藏品权益
 */
export const CollectionBenefitForPad = ({benefitList, claimFlag, nftNo})=> {
  //claimFlag: 0未领取   1已领取  2部分领取
  const getClaimFlag = ()=> {
    if(!nftNo){
      return ''
    }
    if(claimFlag === 0){
      return <span className="num">未领取</span>
    }else if(claimFlag === 1){
      return <span className="num" style={{ color: '#B89969' }}>已领取</span>
    }else if(claimFlag === 2){
      return <span className="num" style={{ color: '#B89969' }}>部分领取</span>
    }
  }
  return (
    <div className={`collection_no`}>
      <div className="cell">
        <span className="collection-num">藏品权益</span>
        {getClaimFlag()}
      </div>
      {benefitList?.length > 0 && benefitList.map((item, index) => {
        return (
          <div>
            <div className="num">{item.benefitName}</div>
            <br/>
          </div>
        )})}
    </div>
  )
}
export {
    CollectionTitle,
    CollectionNo,
    CollectionBenefit
};